import { Flex, Spinner } from '@applyboard/crystal-ui';

import { useMediaQuery } from '~/hooks/useMediaQuery';
import { ErrorHandler } from '~/pages/ErrorPage';
import { DesktopLayout } from './DesktopLayout';
import { TabletLayout } from './TabletLayout';
import { MobileLayout } from './MobileLayout';
import { useGradeConversionPageData } from '../hooks/useGradeConversionPageData';

export const GradeConversionDetailsLayout = () => {
  const { isUltraWide, isWide, isNormal, isNarrow, isUltraNarrow, isMobile } = useMediaQuery();
  const data = useGradeConversionPageData();

  if (data.isLoading) {
    return (
      <Flex p={5} gap={5} align="center" direction="column" role="progressbar">
        <Spinner size="xl" />
      </Flex>
    );
  }

  if (!data.conversionTable || !data.gradeSchema || data.error) {
    return (
      <ErrorHandler
        error={data.error ?? new Error('Failed to load the grade conversion details.')}
        customMessage="Failed to load the grade conversion details."
      />
    );
  }

  const layoutProps = {
    conversionTable: data.conversionTable,
    gradeSchema: data.gradeSchema,
    gradePointMappings: data.gradePointMappings,
    educationLevels: data.educationLevels,
    countries: data.countries,
  };

  if (isUltraWide || isWide) {
    return <DesktopLayout {...layoutProps} />;
  }

  if (isNormal || isNarrow || isUltraNarrow) {
    return <TabletLayout {...layoutProps} />;
  }

  if (isMobile) {
    return <MobileLayout {...layoutProps} />;
  }

  // should not reach here
  return <DesktopLayout {...layoutProps} />;
};
